<template>
	<v-sheet id="sheetMap" class="d-flex">
		<div id="map" ref="map">
		</div>
	</v-sheet>
</template>

<script>
	import { mapState, mapGetters } from 'vuex'
	import Infobox from '@/components/Infobox'
	export default {
		components: {
			Infobox
		},
		props: {
			cas: null
		},
		data() {
			return {
				map: {},
				infoboxes: [],
				pushpins: [],
				apiLoaded: false,
				description: ``
			}
		},
		mounted() {
			let self = this;
			window[self.getInitCallbackFnName()] = function () {
				delete window[self.getInitCallbackFnName];
				self.apiLoaded = true;
				self.initMap()
				self.chargerInfoMap(self.cas)
			};
			this.$loadScript(this.getMapApiUrl())
				.then(() => {
				})
				.catch((err) => {
					// eslint-disable-next-line no-console
					console.log(err)
				});

		},
		watch: {
			cas: function (val) {
				if (this.apiLoaded) {
					this.chargerInfoMap(val)
				}
			}
		},
		computed: {
			...mapState({
				listeSecteursActivites: state => state.SecteursActivites
			}),
			...mapGetters({ GetTrad: 'Traduction/GET_BY_ID' })
		},
		methods: {
			getMapApiUrl() {
				var bingMapUrl = process.env.VUE_APP_BING_MAPS_API_URL
				var apiKey = process.env.VUE_APP_BING_MAPS_API_KEY
				return bingMapUrl.replace('{callback}', this.getInitCallbackFnName()).replace('{key}', apiKey);
			},
			getInitCallbackFnName() {
				return 'mapInitializeCallback_' + this._uid;
			},
			initMap() {
				var mapElement = this.$refs.map;
				var navigationBarMode = Microsoft.Maps.NavigationBarMode
				this.map = new Microsoft.Maps.Map(mapElement, {
					navigationBarMode: navigationBarMode ? navigationBarMode.compact : null, maxZoom: 17, zoom: 0, showMapTypeSelector: false,
					customMapStyle: {
						elements: {
							area: { fillColor: '#b6e591' },
							water: { fillColor: '#75cff0' },
							tollRoad: { fillColor: '#ffffff', strokeColor: '#ffffff' },
							arterialRoad: { fillColor: '#ffffff', strokeColor: '#ffffff' },
							road: { fillColor: '#ffffff', strokeColor: '#ffffff' },
							street: { fillColor: '#ffffff', strokeColor: '#ffffff' },
							transit: { fillColor: '#000000' }
						},
						settings: {
							landColor: '#efe9e1'
						}
					},
					showTermsLink: false
				});
			},
			chargerInfoMap(cas) {
				if (this.map) {
					if (this.map.entities != null) {
						this.map.entities.clear()
					}
					this.infoboxes.forEach(function (infobox) {
						infobox.setMap(undefined);
					})
					this.infoboxes = []
					var self = this
					var locations = []
					var casDescription = ''

					cas.forEach((pin) => {
            if (!pin.Geolocalisation) return
            
						var location = new Microsoft.Maps.Location(pin.Geolocalisation.Latitude, pin.Geolocalisation.Longitude, { title: pin.Titre })
						var pushpin = new Microsoft.Maps.Pushpin(location, { icon: pin.PointeurCarte, anchor: new Microsoft.Maps.Point(12, 36) })
						//var secteurActivite = ''
						if (pin.Deleguation == true) {
							self.description = `<div class="customInfobox v-card v-sheet v-sheet--tile theme--light">
																<div tabindex="-1" class="v-list-item v-list-item--three-line theme--light">
																		<button type="button" class="v-btn v-btn--absolute v-btn--contained v-btn--fab v-btn--right v-btn--round v-btn--top theme--dark v-size--x-small pink">
																				<span class="v-btn__content">
																						<i aria-hidden="true" class="v-icon notranslate mdi mdi-close theme--dark"></i>
																				</span>
																		</button>
																<div class="v-card__text" style="font-size: 10px;">
															<div>
																<div class="v-list-item__title mb-2">
																		{titre}
																</div>
														</div>
														<div>
																{trad117}

														</div>
														<div>
																<span class="font-weight-bold">{trad116} : </span>  {territoires}
														</div>
														<div>
																<span class="font-weight-bold">{trad113} : </span>  <a href="{sitewebUtilisateur}" target="_blank" style="text-decoration:none;color:black;">{sitewebUtilisateur1}</a>
														</div>
														</div>
														</div>
														</div>`
							casDescription = self.description.replace('{titre}', pin.Titre)
							
								.replace('{trad113}', this.GetTrad(113))
								.replace('{trad112}', this.GetTrad(112))
								.replace('{trad116}', this.GetTrad(116))
								.replace('{trad117}', this.GetTrad(117))
								.replace('{territoires}', pin.TerritoiresCouverts)
								.replace('{sitewebUtilisateur}', pin.SiteWebUtilisateur)
								.replace('{sitewebUtilisateur1}', pin.SiteWebUtilisateur)

						} else {

							var secteurActivite = ''
							pin.SecteurActiviteIcone.forEach(function (icone) {
								secteurActivite += `<div class="v-responsive v-image" style="max-height: 30px; width: 24px; display: inline-block; vertical-align: middle; margin-bottom: 0.2em; margin-right: 0.2em;">
																									 <div class="v-responsive__sizer" style="padding-bottom: 84.6154%;"></div>
																									 <div class="v-image__image v-image__image--cover" style="background-image: url(&quot;{icone}&quot;); background-position: center center;"></div>
																									 <div class="v-responsive__content" style="width: 260px;"></div>
																								</div>`
								secteurActivite = secteurActivite.replace('{icone}', icone)
							})

							self.description = `<div class="customInfobox v-card v-sheet v-sheet--tile theme--light">
																<div tabindex="-1" class="v-list-item v-list-item--three-line theme--light">
																		<button type="button" class="v-btn v-btn--absolute v-btn--contained v-btn--fab v-btn--right v-btn--round v-btn--top theme--dark v-size--x-small pink">
																				<span class="v-btn__content">
																						<i aria-hidden="true" class="v-icon notranslate mdi mdi-close theme--dark"></i>
																				</span>
																		</button>
																<div class="v-card__text" style="font-size: 10px;">
															<div>
																<div class="v-list-item__title mb-2">
																		{titre}
																</div>
														</div>
														<div>
																<span class="font-weight-bold">{trad95} : </span> <a href="{sitewebUtilisateur}" target="_blank" style="text-decoration:none;color:black;">{entrepriseUtilisatrice}</a>
														</div>
														<div>
																<span class="font-weight-bold">{trad94} : </span> <a href="{sitewebDeveloppeur}" target="_blank" style="text-decoration:none;color:black;">{entrepriseDeveloppeuse}</a>
														</div>
														<div>
																<span class="font-weight-bold">{trad90} :</span> {secteurActivite}
														</div>
														</div>
														<div class="v-card__actions">
																<button type="button" class="v-btn v-btn--absolute v-btn--bottom v-btn--fab v-btn--right v-btn--round theme--dark elevation-5 v-size--x-small" style="bottom: 0px;background-color:#71BF4B;"><span class="v-btn__content">{trad101}</span>
																</button>
														</div>
														</div>
														</div>`

							casDescription = self.description.replace('{titre}', pin.Titre)
								.replace('{trad95}', this.GetTrad(95))
								.replace('{entrepriseUtilisatrice}', pin.EntrepriseUtilisatrice)
								.replace('{trad94}', this.GetTrad(94))
								.replace('{entrepriseDeveloppeuse}', pin.EntrepriseDeveloppeuse)
								.replace('{trad90}', this.GetTrad(90))
								.replace('{secteurActivite}', secteurActivite)
								.replace('{trad101}', this.GetTrad(101))
								.replace('{sitewebUtilisateur}', pin.SiteWebUtilisateur)
								.replace('{sitewebDeveloppeur}', pin.SiteWebVendeur)
						}

						pin.SecteurActiviteIcone.forEach(function (icone) {


							secteurActivite += `<div class="v-responsive v-image" style="max-height: 30px; width: 24px; display: inline-block; vertical-align: middle; margin-bottom: 0.2em; margin-right: 0.2em;">
																									 <div class="v-responsive__sizer" style="padding-bottom: 84.6154%;"></div>
																									 <div class="v-image__image v-image__image--cover" style="background-image: url(&quot;{icone}&quot;); background-position: center center;"></div>
																									 <div class="v-responsive__content" style="width: 260px;"></div>
																								</div>`
							secteurActivite = secteurActivite.replace('{icone}', icone)
						})

						var infobox = new Microsoft.Maps.Infobox(location, {
							title: pin.Titre, visible: false,
							htmlContent: casDescription,
						})
						infobox.setMap(this.map)
						this.infoboxes.push(infobox)
						this.map.entities.push(pushpin)
						Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (e) {
							self.showInfoBox(e, infobox)
						})
						//if (pin.Deleguation == false) {
						Microsoft.Maps.Events.addHandler(infobox, 'click', function (e) { self.handleClickInfoBox(e, pin) })

						Microsoft.Maps.Events.addHandler(pushpin, 'click', function (e) {
							self.showInfoBox(e, infobox)
						})
						//}
						Microsoft.Maps.Events.addHandler(pushpin, 'mouseout', function (e) {
							//e.target.setOptions({ icon: 'red-marker-40.png' })
							infobox.setOptions({ visible: false })
						})
						locations.push(location)
						this.pushpins.push(pushpin)
					})
					//new Microsoft.Maps.loadModule('Microsoft.Maps.SpatialMath', () => {
					//    var bounds = Microsoft.Maps.LocationRect.fromLocations(locations)
					//    var centroid = Microsoft.Maps.SpatialMath.Geometry.centroid(locations)
					//    this.map.setView({ center: centroid, /*bounds: bounds, zoom: 1*/ })
					//});
					Microsoft.Maps.Events.addHandler(this.map, 'viewchangeend', function (e) { self.viewChanged(e) });
				}
			},
			viewChanged(e) {
				var bounds = this.map.getBounds()
				this.$emit('filtrerCas', { locationRect: bounds })

			},
			handleClickInfoBox(e, cas) {
				// Bouton close
				var isCloseAction = e.originalEvent.target.className.includes("mdi-close")
				if (isCloseAction == true) {
					e.target.setOptions({ visible: false })
					//this.pushpins.forEach(function (p) {
					//    p.setOptions({ icon: 'red-marker-40.png' })
					//})
				}
				else if(!cas.Deleguation) { 
					this.selectionCas(cas)
				}
			},
			selectionCas: function (cas) {
				this.$emit('selectionnerCas', cas)
			},
			showInfoBox(e, infobox) {
				//this.pushpins.forEach(function (p) {
				//    p.setOptions({ icon: 'red-marker-40.png' })
				//})
				//e.target.setOptions({ icon: 'blue-marker-40.png' });
				this.infoboxes.forEach(function (i) {
					i.setOptions({ visible: false })
				})

				infobox.setOptions({ visible: true, location: e.target.getLocation(), offset: new Microsoft.Maps.Point(7, 22) })
			}
		}
	}
</script>
<style>
	@media only screen and (max-width:450px) {
		#sheetMap {
			min-height: 468px !important;
		}
	}

	@media only screen and (min-width:900px) and (max-width:1024px) {
		#sheetMap {
			min-height: 600px !important;
		}
	}

	#sheetMap {
		min-height: 640px;
	}

	#map {
		z-index: 0;
	}
</style>